<!-- 翻车机报警处理 -->
<template>
  <div class="wagon-alarm-page">
    <div v-loading="overviewLoading" class="alarm-summary">
      <div v-for="item in summaryItems" :key="item.key" class="summary-item">
        <div class="summary-label">{{ item.label }}</div>
        <div class="summary-value">{{ item.value }}</div>
      </div>
    </div>

    <el-alert v-if="overviewError" class="state-alert" type="warning" :closable="false" show-icon>
      <span slot="title">{{ overviewError }}</span>
    </el-alert>

    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @selection-change="selectionChange"
      @on-load="onLoad"
      @before-open="beforeOpen"
    >
      <template slot="menuLeft">
        <el-button
          v-if="hasPermission('wagontippler_alarm_handling_batch_confirm')"
          type="warning"
          size="small"
          plain
          icon="el-icon-finished"
          :disabled="selectionList.length === 0"
          @click="openConfirmDialog('batch')"
        >批量确认</el-button>
        <el-button
          v-if="hasPermission('wagontippler_alarm_handling_one_click_confirm')"
          type="danger"
          size="small"
          plain
          icon="el-icon-circle-check"
          @click="openConfirmDialog('oneClick')"
        >一键确认</el-button>
      </template>

      <template slot="alertStatus" slot-scope="{ row }">
        <el-tag size="small" :type="statusTagType(row.alertStatus)">
          {{ statusLabel(row.alertStatus) }}
        </el-tag>
      </template>

      <template slot="latestProcessStep" slot-scope="{ row }">
        {{ stepLabel(row.latestProcessStep || row.latestStep || row.processStep) }}
      </template>

      <template slot="currentValue" slot-scope="{ row }">
        {{ valueText(row.currentValue) }}
      </template>

      <template slot="thresholdValue" slot-scope="{ row }">
        {{ valueText(row.thresholdValue) }}
      </template>

      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="small" icon="el-icon-view" @click="openDetail(row)">查看</el-button>
        <el-button
          v-if="hasPermission('wagontippler_alarm_handling_confirm') && canProcess(row)"
          type="text"
          size="small"
          icon="el-icon-check"
          @click="openStepDialog(row, 'CONFIRM')"
        >确认</el-button>
        <el-button
          v-if="hasPermission('wagontippler_alarm_handling_dispatch') && canProcess(row)"
          type="text"
          size="small"
          icon="el-icon-s-promotion"
          @click="openStepDialog(row, 'DISPATCH')"
        >派单</el-button>
        <el-button
          v-if="hasPermission('wagontippler_alarm_handling_repair') && canProcess(row)"
          type="text"
          size="small"
          icon="el-icon-setting"
          @click="openStepDialog(row, 'REPAIR')"
        >修复</el-button>
        <el-button
          v-if="hasPermission('wagontippler_alarm_handling_verify') && canProcess(row)"
          type="text"
          size="small"
          icon="el-icon-circle-check"
          @click="openStepDialog(row, 'VERIFY')"
        >验证</el-button>
        <el-button
          v-if="hasPermission('wagontippler_alarm_handling_export_pdf')"
          type="text"
          size="small"
          icon="el-icon-download"
          :loading="exportingId === row.id"
          @click="handleExportPdf(row)"
        >导出PDF</el-button>
      </template>
    </avue-crud>

    <dialog-reset slotShow height="70vh" top="8vh" width="70%" title="报警详情" :visible.sync="detailVisible">
      <div v-loading="detailLoading" class="detail-body">
        <template v-if="detail">
          <div class="detail-section">
            <div class="section-title">基础信息</div>
            <div class="detail-grid">
              <div v-for="item in detailFields" :key="item.label" class="detail-item" :class="{ 'detail-item--wide': item.wide }">
                <span class="detail-item__label">{{ item.label }}</span>
                <span class="detail-item__value">{{ item.value || '-' }}</span>
              </div>
            </div>
          </div>

          <div class="detail-actions">
            <el-button type="primary" size="small" icon="el-icon-plus" :disabled="!canProcess(detailAlarm)" @click="openNextStepFromDetail">提交下一步</el-button>
            <el-button type="success" size="small" icon="el-icon-download" :loading="exportingId === detailAlarm.id" @click="handleExportPdf(detailAlarm)">导出PDF</el-button>
          </div>

          <div class="detail-section">
            <div class="section-title">处理时间线</div>
            <el-timeline v-if="timeline.length">
              <el-timeline-item
                v-for="(node, index) in timeline"
                :key="index"
                :timestamp="node.processTime || node.createTime || ''"
                placement="top"
                :type="node.processStatus === 'DONE' || node.done ? 'success' : 'primary'"
              >
                <div class="timeline-node">
                  <div class="timeline-node__title">{{ stepLabel(node.processStep || node.step) }}</div>
                  <div class="timeline-node__meta">{{ node.processorName || node.handler || '-' }}</div>
                  <div class="timeline-node__content">{{ node.processContent || node.content || node.remark || '-' }}</div>
                  <div v-if="imageList(node.imageUrls).length" class="image-list">
                    <el-image
                      v-for="(url, idx) in imageList(node.imageUrls)"
                      :key="url + idx"
                      class="evidence-image"
                      :src="url"
                      :preview-src-list="imageList(node.imageUrls)"
                      fit="cover"
                    >
                      <div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
                    </el-image>
                  </div>
                </div>
              </el-timeline-item>
            </el-timeline>
            <el-empty v-else description="暂无处理记录" />
          </div>
        </template>
        <el-empty v-else-if="!detailLoading" description="暂无详情数据" />
      </div>
    </dialog-reset>

    <dialog-reset slotShow height="58vh" top="8vh" width="640px" :title="stepDialogTitle" :visible.sync="stepVisible">
      <el-form ref="stepForm" :model="stepForm" :rules="stepRules" label-width="110px">
        <el-form-item label="处理节点">
          <el-input :value="stepLabel(stepForm.processStep)" disabled />
        </el-form-item>
        <el-form-item label="处理说明" prop="processContent">
          <el-input v-model.trim="stepForm.processContent" type="textarea" :rows="4" maxlength="1000" show-word-limit placeholder="请输入处理说明" />
        </el-form-item>
        <el-form-item label="图片证据" prop="imageUrls">
          <el-upload
            class="step-image-upload"
            :action="uploadAction"
            :headers="uploadHeaders"
            list-type="picture-card"
            :limit="5"
            :file-list="stepImageFiles"
            :on-success="handleStepImageSuccess"
            :on-remove="handleStepImageRemove"
            :on-preview="handleImagePreview"
            :before-upload="beforeImageUpload"
            accept="image/*"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model.trim="stepForm.remark" type="textarea" :rows="2" maxlength="500" show-word-limit placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <span slot="dialog_footer">
        <el-button @click="stepVisible = false">取消</el-button>
        <el-button type="primary" :loading="actionLoading" @click="submitStep">提交</el-button>
      </span>
    </dialog-reset>

    <dialog-reset slotShow height="36vh" top="12vh" width="520px" :title="confirmDialogTitle" :visible.sync="confirmVisible">
      <el-form ref="confirmForm" :model="confirmForm" :rules="confirmRules" label-width="100px">
        <el-form-item label="处理结果" prop="processResult">
          <el-input v-model.trim="confirmForm.processResult" type="textarea" :rows="4" maxlength="200" show-word-limit placeholder="请输入确认说明" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model.trim="confirmForm.remark" type="textarea" :rows="2" maxlength="200" show-word-limit placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <span slot="dialog_footer">
        <el-button @click="confirmVisible = false">取消</el-button>
        <el-button type="primary" :loading="actionLoading" @click="submitConfirm">确定</el-button>
      </span>
    </dialog-reset>

    <el-dialog :visible.sync="previewVisible" append-to-body width="720px">
      <img :src="previewUrl" class="preview-image" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import crudMixins from '@/mixins/crud-mixins'
import { searchTimeConfig } from '@/basic-common/util/common'
import { getToken } from '@/util/auth'
import website from '@/config/website'
import {
  batchConfirm,
  exportClosedLoopPdf,
  getDetail,
  getList,
  getOverview,
  oneClickConfirm,
  submitProcessStep
} from './api'

const STATUS_OPTIONS = [
  { label: '待确认', value: 1, tag: 'warning' },
  { label: '处理中', value: 2, tag: 'primary' },
  { label: '已处理', value: 3, tag: 'success' },
  { label: '已关闭', value: 4, tag: 'success' }
]

const STEP_OPTIONS = [
  { label: '确认', value: 'CONFIRM' },
  { label: '派单', value: 'DISPATCH' },
  { label: '修复', value: 'REPAIR' },
  { label: '验证', value: 'VERIFY' }
]

function responseData(res) {
  const body = res && res.data !== undefined ? res.data : res
  if (body && body.data !== undefined) return body.data
  return body || {}
}

function responseSuccess(res) {
  const body = res && res.data !== undefined ? res.data : res
  return !body || body.code === undefined || Number(body.code) === 200
}

function responseMessage(res, fallback) {
  const body = res && res.data !== undefined ? res.data : res
  return (body && (body.msg || body.message)) || fallback
}

function downloadPdf(blobData, filename) {
  const blob = blobData instanceof Blob ? blobData : new Blob([blobData], { type: 'application/pdf' })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export default {
  name: 'wagontippler-alarm-handling',
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList, getDetail },
      overviewLoading: false,
      overviewError: '',
      overview: {
        total: 0,
        untreated: 0,
        processing: 0,
        closed: 0,
        overdue: 0
      },
      detailVisible: false,
      detailLoading: false,
      detail: null,
      detailAlarm: {},
      stepVisible: false,
      stepRow: null,
      stepForm: {
        alarmRecordId: null,
        processStep: '',
        processContent: '',
        imageUrls: [],
        remark: ''
      },
      stepImageFiles: [],
      stepRules: {
        processContent: [{ required: true, message: '请输入处理说明', trigger: 'blur' }]
      },
      confirmVisible: false,
      confirmType: '',
      confirmForm: {
        processResult: '',
        remark: ''
      },
      confirmRules: {
        processResult: [{ required: true, message: '请输入确认说明', trigger: 'blur' }]
      },
      actionLoading: false,
      exportingId: null,
      previewVisible: false,
      previewUrl: '',
      option: {
        ...this.$store.state.publicOption,
        menu: true,
        selection: true,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        viewBtn: false,
        menuWidth: 340,
        dialogWidth: '1200px',
        dialogHeight: '900px',
        column: [
          {
            label: '设备名称',
            prop: 'deviceName',
            width: 160,
            search: true,
            overHidden: true,
            type: 'input',
            searchPlaceholder: '请输入设备名称',
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true
          },
          {
            label: '设备类型',
            prop: 'deviceType',
            hide: true,
            viewDisplay: true,
            search: true,
            width: 120,
            type: 'select',
            dicUrl: '/api/blade-system/dict-biz/dictionary?code=base_device_type',
            dicFormatter: true,
            props: {
              label: 'dictValue',
              value: 'dictKey'
            },
            dataType: 'string'
          },
          {
            label: '异常类型',
            prop: 'abnormalType',
            search: true,
            width: 110,
            type: 'select',
            dicData: [
              { label: '超时', value: '超时' },
              { label: '中断', value: '中断' },
              { label: '顺序错误', value: '顺序错误' }
            ],
            props: {
              label: 'label',
              value: 'value'
            },
            dataType: 'string'
          },
          {
            label: '报警等级',
            prop: 'alarmLevel',
            search: true,
            width: 110,
            type: 'select',
            dicData: [
              { label: '预警', value: '1' },
              { label: '一般', value: '2' },
              { label: '紧急', value: '3' }
            ],
            props: {
              label: 'label',
              value: 'value'
            },
            dataType: 'string'
          },
          {
            label: '报警状态',
            prop: 'alertStatus',
            type: 'select',
            overHidden: true,
            search: true,
            width: 110,
            slot: true,
            dicUrl: '/api/blade-system/dict-biz/dictionary?code=alert_status',
            dataType: 'string',
            props: {
              label: 'dictValue',
              value: 'dictKey'
            }
          },
          {
            label: '报警时间',
            prop: 'alertTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 180,
            addDisplay: false,
            editDisplay: false
          },
          {
            label: '当前数值',
            prop: 'currentValue',
            slot: true,
            hide: true,
            viewDisplay: true,
            type: 'number',
            precision: 8
          },
          {
            label: '阈值数值',
            prop: 'thresholdValue',
            slot: true,
            hide: true,
            viewDisplay: true,
            type: 'number',
            precision: 8
          },
          {
            label: '报警内容',
            prop: 'alarmContent',
            type: 'textarea',
            span: 24,
            minRows: 3,
            search: false,
            overHidden: true,
            minWidth: 240
          },
          {
            label: '最新节点',
            prop: 'latestProcessStep',
            slot: true,
            align: 'center',
            width: 110,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true
          },
          {
            label: '处理人',
            prop: 'processorName',
            align: 'center',
            width: 100,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true
          },
          {
            label: '处理时间',
            prop: 'processTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 180,
            addDisplay: false,
            editDisplay: false
          },
          {
            label: '处理结果',
            prop: 'processResult',
            type: 'textarea',
            span: 24,
            minRows: 3,
            hide: true,
            search: false
          },
          {
            ...searchTimeConfig,
            paramsKey: ['startTime', 'endTime'],
            search: true
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['permission']),
    summaryItems() {
      return [
        { key: 'total', label: '全部报警', value: this.formatCount(this.overview.total) },
        { key: 'untreated', label: '待确认', value: this.formatCount(this.overview.untreated || this.overview.unconfirmed || this.overview.waitConfirm) },
        { key: 'processing', label: '处理中', value: this.formatCount(this.overview.processing) },
        { key: 'closed', label: '已关闭', value: this.formatCount(this.overview.closed) },
        { key: 'overdue', label: '超时未处理', value: this.formatCount(this.overview.overdue || this.overview.timeout || this.overview.timeoutUnprocessed) }
      ]
    },
    uploadAction() {
      return '/produce/api/blade-resource/oss/endpoint/put-file-attach'
    },
    uploadHeaders() {
      const token = getToken()
      if (!token) return {}
      const bearer = 'Bearer ' + token
      return {
        Authorization: bearer,
        [website.tokenHeader]: bearer
      }
    },
    stepDialogTitle() {
      return `${this.stepLabel(this.stepForm.processStep)}节点`
    },
    confirmDialogTitle() {
      return this.confirmType === 'oneClick' ? '一键确认' : '批量确认'
    },
    timeline() {
      const detail = this.detail || {}
      return detail.timeline || detail.processSteps || detail.steps || detail.processList || []
    },
    detailFields() {
      const row = this.detailAlarm || {}
      return [
        { label: '设备名称', value: row.deviceName },
        { label: '处理状态', value: this.statusLabel(row.alertStatus) },
        { label: '报警类型', value: row.type || row.abnormalType },
        { label: '提醒类型', value: row.alertType || row.alarmLevel },
        { label: '报警内容', value: row.alarmContent, wide: true },
        { label: '当前值', value: this.valueText(row.currentValue) },
        { label: '阈值', value: this.valueText(row.thresholdValue) },
        { label: '报警时间', value: row.alertTime },
        { label: '最新节点', value: this.stepLabel(row.latestProcessStep || row.latestStep || row.processStep) },
        { label: '处理人', value: row.processorName },
        { label: '处理时间', value: row.processTime },
        { label: '处理结果', value: row.processResult, wide: true }
      ]
    }
  },
  methods: {
    initCardData() {
      this.loadOverview()
    },
    hasPermission(code) {
      return !this.permission || this.permission[code] !== false
    },
    buildAlarmHandlingQuery() {
      return this.formatParams(Object.assign({}, this.defaultParams, this.query))
    },
    loadOverview() {
      const params = this.queryData || this.buildAlarmHandlingQuery()
      this.overviewLoading = true
      this.overviewError = ''
      getOverview(params).then(res => {
        const data = responseData(res)
        this.overview = {
          total: Number(data.total || data.totalCount || 0),
          untreated: Number(data.untreated || data.unconfirmed || data.waitConfirm || data.unhandledCount || 0),
          processing: Number(data.processing || 0),
          closed: Number(data.closed || data.handledCount || 0),
          overdue: Number(data.overdue || data.timeout || data.timeoutUnprocessed || 0)
        }
      }).catch(e => {
        console.warn(e)
        this.overview = {}
        this.overviewError = (e && e.message) || '统计概览加载失败'
      }).finally(() => {
        this.overviewLoading = false
      })
    },
    refreshHandlingList() {
      this.onLoad(this.page, this.query)
    },
    formatCount(value) {
      return value === null || value === undefined || value === '' ? 0 : value
    },
    statusLabel(status) {
      const option = STATUS_OPTIONS.find(item => String(item.value) === String(status))
      return option ? option.label : (status || '-')
    },
    statusTagType(status) {
      const option = STATUS_OPTIONS.find(item => String(item.value) === String(status))
      return option ? option.tag : 'info'
    },
    stepLabel(step) {
      const option = STEP_OPTIONS.find(item => String(item.value) === String(step))
      return option ? option.label : (step || '未开始')
    },
    valueText(value) {
      if (value === null || value === undefined || value === '') return '-'
      return String(value)
    },
    isClosed(row) {
      return row && ['4', 'closed', 'CLOSED'].indexOf(String(row.alertStatus)) > -1
    },
    canProcess(row) {
      return row && row.id && !this.isClosed(row)
    },
    openDetail(row) {
      this.detailVisible = true
      this.detailLoading = true
      this.detail = null
      this.detailAlarm = { ...row }
      getDetail(row.id).then(res => {
        if (!responseSuccess(res)) {
          this.$message.error(responseMessage(res, '加载报警详情失败'))
          return
        }
        const data = responseData(res)
        this.detail = data || {}
        this.detailAlarm = data.alarm || data.record || data.detail || { ...row, ...data }
      }).catch(e => {
        console.warn(e)
        this.$message.error((e && e.message) || '加载报警详情失败')
      }).finally(() => {
        this.detailLoading = false
      })
    },
    openNextStepFromDetail() {
      const next = this.resolveNextStep(this.detailAlarm)
      this.openStepDialog(this.detailAlarm, next)
    },
    resolveNextStep(row) {
      const current = row && (row.latestProcessStep || row.latestStep || row.processStep)
      const idx = STEP_OPTIONS.findIndex(item => item.value === current)
      if (idx >= 0 && idx < STEP_OPTIONS.length - 1) return STEP_OPTIONS[idx + 1].value
      if (this.isClosed(row)) return 'VERIFY'
      return 'CONFIRM'
    },
    openStepDialog(row, step) {
      if (!this.canProcess(row)) {
        this.$message.warning('该报警已关闭，不能继续提交处理节点')
        return
      }
      this.stepRow = row
      this.stepForm = {
        alarmRecordId: row.id,
        processStep: step,
        processContent: '',
        imageUrls: [],
        remark: ''
      }
      this.stepImageFiles = []
      this.stepVisible = true
      this.$nextTick(() => this.$refs.stepForm && this.$refs.stepForm.clearValidate())
    },
    beforeImageUpload(file) {
      const isImage = file.type && file.type.indexOf('image/') === 0
      if (!isImage) this.$message.warning('请上传图片文件')
      const isLt10M = file.size / 1024 / 1024 <= 10
      if (!isLt10M) this.$message.warning('图片大小不能超过10MB')
      return isImage && isLt10M
    },
    handleStepImageSuccess(res, file, fileList) {
      const url = this.resolveUploadUrl(res)
      if (url) file.url = url
      this.syncStepImages(fileList)
    },
    handleStepImageRemove(file, fileList) {
      this.syncStepImages(fileList)
    },
    syncStepImages(fileList) {
      this.stepImageFiles = fileList.map(item => ({
        ...item,
        url: item.url || this.resolveUploadUrl(item.response)
      })).filter(item => item.url)
      this.stepForm.imageUrls = this.stepImageFiles.map(item => item.url)
    },
    handleImagePreview(file) {
      this.previewUrl = file.url || this.resolveUploadUrl(file.response)
      this.previewVisible = !!this.previewUrl
    },
    resolveUploadUrl(res) {
      if (!res) return ''
      const data = res.data || {}
      return data.link || data.url || data.fileUrl || data.fullLink || ''
    },
    imageList(value) {
      if (!value) return []
      if (Array.isArray(value)) return value.filter(Boolean)
      const text = String(value).trim()
      if (!text) return []
      if (text[0] === '[') {
        try {
          const arr = JSON.parse(text)
          return Array.isArray(arr) ? arr.filter(Boolean) : []
        } catch (e) {
          return []
        }
      }
      return text.split(',').map(item => item.trim()).filter(Boolean)
    },
    submitStep() {
      this.$refs.stepForm.validate(valid => {
        if (!valid) return
        const payload = {
          alarmRecordId: this.stepForm.alarmRecordId,
          processStep: this.stepForm.processStep,
          processContent: this.stepForm.processContent,
          imageUrls: JSON.stringify(this.stepForm.imageUrls || []),
          remark: this.stepForm.remark
        }
        this.actionLoading = true
        submitProcessStep(payload).then(res => {
          if (!responseSuccess(res)) {
            this.$message.error(responseMessage(res, '提交处理节点失败'))
            return
          }
          this.$message.success(responseMessage(res, '提交成功'))
          this.stepVisible = false
          this.refreshHandlingList()
          if (this.detailVisible && this.stepRow) this.openDetail(this.stepRow)
        }).catch(e => {
          console.warn(e)
          this.$message.error((e && e.message) || '提交处理节点失败')
        }).finally(() => {
          this.actionLoading = false
        })
      })
    },
    openConfirmDialog(type) {
      if (type === 'batch' && this.selectionList.length === 0) {
        this.$message.warning('请选择需要确认的报警记录')
        return
      }
      this.confirmType = type
      this.confirmForm = {
        processResult: '',
        remark: ''
      }
      this.confirmVisible = true
      this.$nextTick(() => this.$refs.confirmForm && this.$refs.confirmForm.clearValidate())
    },
    submitConfirm() {
      this.$refs.confirmForm.validate(valid => {
        if (!valid) return
        const request = this.confirmType === 'oneClick'
          ? this.submitOneClickConfirm
          : this.submitBatchConfirm
        request()
      })
    },
    submitBatchConfirm() {
      const alarmIds = this.selectionList.map(item => item.id).filter(Boolean)
      if (!alarmIds.length) {
        this.$message.warning('请选择需要确认的报警记录')
        return
      }
      this.$confirm(`确认批量确认 ${alarmIds.length} 条翻车机报警？`, '批量确认', { type: 'warning' }).then(() => {
        const payload = {
          processResult: this.confirmForm.processResult,
          alertStatus: 2,
          remark: this.confirmForm.remark
        }
        return this.executeConfirm(() => batchConfirm(alarmIds.join(','), payload))
      }).catch(() => {})
    },
    submitOneClickConfirm() {
      this.$confirm('确认一键确认当前查询条件下的翻车机报警？', '一键确认', { type: 'warning' }).then(() => {
        const payload = {
          query: this.buildAlarmHandlingQuery(),
          handling: {
            processResult: this.confirmForm.processResult,
            alertStatus: 2,
            remark: this.confirmForm.remark
          }
        }
        return this.executeConfirm(() => oneClickConfirm(payload))
      }).catch(() => {})
    },
    executeConfirm(request) {
      this.actionLoading = true
      return request().then(res => {
        if (!responseSuccess(res)) {
          this.$message.error(responseMessage(res, '确认失败'))
          return
        }
        this.$message.success(responseMessage(res, '确认成功'))
        this.confirmVisible = false
        this.refreshHandlingList()
      }).catch(e => {
        console.warn(e)
        this.$message.error((e && e.message) || '确认失败')
      }).finally(() => {
        this.actionLoading = false
      })
    },
    handleExportPdf(row) {
      if (!row || !row.id) {
        this.$message.warning('缺少报警记录ID')
        return
      }
      this.exportingId = row.id
      exportClosedLoopPdf(row.id).then(res => {
        downloadPdf(res.data || res, `翻车机报警闭环报告_${row.id}_${Date.now()}.pdf`)
        this.$message.success('导出成功')
      }).catch(e => {
        console.warn(e)
        this.$message.error((e && e.message) || '导出失败')
      }).finally(() => {
        this.exportingId = null
      })
    }
  }
}
</script>

<style scoped lang="scss">
.wagon-alarm-page {
  .alarm-summary {
    display: grid;
    grid-template-columns: repeat(5, minmax(120px, 1fr));
    gap: 8px;
    margin-bottom: 8px;
  }

  .summary-item {
    min-height: 56px;
    padding: 8px 12px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fff;
  }

  .summary-label {
    line-height: 20px;
    font-size: 12px;
    color: #606266;
  }

  .summary-value {
    line-height: 24px;
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    word-break: break-all;
  }

  .state-alert {
    margin-bottom: 8px;
  }
}

.detail-body {
  min-height: 360px;
  padding: 0 8px 20px;
}

.detail-section {
  margin-bottom: 18px;
}

.section-title {
  margin-bottom: 10px;
  padding-left: 8px;
  border-left: 3px solid #409eff;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border-top: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
}

.detail-item {
  display: flex;
  min-height: 40px;
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

.detail-item--wide {
  grid-column: span 2;
}

.detail-item__label {
  flex: 0 0 96px;
  padding: 10px 12px;
  background: #f5f7fa;
  color: #606266;
}

.detail-item__value {
  flex: 1;
  min-width: 0;
  padding: 10px 12px;
  color: #303133;
  word-break: break-all;
}

.detail-actions {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.timeline-node__title {
  font-weight: 600;
  color: #303133;
}

.timeline-node__meta {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
}

.timeline-node__content {
  margin-top: 6px;
  color: #606266;
  line-height: 1.6;
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.evidence-image {
  width: 88px;
  height: 88px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.image-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #909399;
  background: #f5f7fa;
}

.step-image-upload ::v-deep .el-upload--picture-card,
.step-image-upload ::v-deep .el-upload-list__item {
  width: 88px;
  height: 88px;
  line-height: 88px;
}

.preview-image {
  display: block;
  max-width: 100%;
  margin: 0 auto;
}

@media (max-width: 1200px) {
  .wagon-alarm-page {
    .alarm-summary {
      grid-template-columns: repeat(3, minmax(120px, 1fr));
    }
  }
}

@media (max-width: 640px) {
  .wagon-alarm-page {
    .alarm-summary {
      grid-template-columns: 1fr;
    }
  }

  .detail-grid {
    grid-template-columns: 1fr;
  }

  .detail-item--wide {
    grid-column: span 1;
  }

  .detail-actions {
    flex-wrap: wrap;
  }
}
</style>
